import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export default function Header() {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    nav(`/orders?q=${encodeURIComponent(q.trim())}`);
  };
  return (
    <header
      data-testid="top-header"
      className="sticky top-0 z-20 bg-white border-b flex items-center gap-4 px-6"
      style={{ borderColor: "#E2E8F0", height: 64 }}
    >
      <form onSubmit={submit} className="flex-1 max-w-[640px] relative">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          data-testid="global-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Globale Suche: Auftragsnummer, KLS-ID, Mitarbeiter, Fahrzeug, Datum, Telekom Konto..."
          className="w-full h-11 pl-10 pr-3 rounded-md border bg-slate-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#0A2540] text-sm"
          style={{ borderColor: "#E2E8F0" }}
        />
      </form>
      <div className="hidden md:flex items-center gap-2 text-xs text-slate-500 mono">
        {new Date().toLocaleString("de-DE")}
      </div>
    </header>
  );
}
